export class RoleRightModel {
    RoleId: number;
    UserRolesRightsList: any;

    constructor() {
        this.RoleId = 0;
        this.UserRolesRightsList = [];
    }
}
export class UserRightModel {
    UserMasterId: number;
    UserRightsList: any;

    constructor() {
        this.UserMasterId = 0;
        this.UserRightsList = [];
    }
}
export class UserModel {
    DomainMasterId: number;
    TravelAgentId: number | null;
    CorporateId: number | null;
    FirstName: string
    MiddleName: string
    LastName: string
    UserEmail: string
    ContactNo: string
    GenderId: number;
    UserName: string;
    RoleId: number;
    DepartmentId: number;
    IsActive: boolean;
    Password: string;
    ConfirmPassword: string;
    UserMasterId: number
    UserType: number

    ImageFile: any;
    ImageName: string;
    ImagePath: string;
    Path: string;
    Type: string;
    Size: number;
    needToUpload: boolean;

    TravelCategoryId: number[];

    TravelType: number;
    SubContinentId: number[] | null;
    RegionId: number[] | null;
    UserId: number;

    constructor() {
        this.DomainMasterId = 0;
        this.TravelAgentId = null;
        this.CorporateId = null;
        this.FirstName = '';
        this.MiddleName = '';
        this.LastName = '';
        this.UserEmail = '';
        this.ContactNo = '';
        this.GenderId = 0;
        this.UserName = '';
        this.RoleId = 0;
        this.DepartmentId = 0;
        this.IsActive = false;
        this.Password = '';
        this.ConfirmPassword = '';
        this.UserMasterId = 0;
        this.UserType = 3;
        this.ImageFile = null;
        this.ImageName = "";
        this.ImagePath = "";
        this.Path = "";
        this.Type = "";
        this.Size = 0;
        this.needToUpload = false;
        this.TravelCategoryId = [];
        this.TravelType = 0;
        this.SubContinentId = null;
        this.RegionId = null;
        this.UserId = 0;
    }
}
export class DepartmentModel {
    DepartmentId: number;
    DepartmentName: string;
    IsActive: boolean;
    UserId: number;
    UserType: number

    constructor() {
        this.DepartmentId = 0;
        this.DepartmentName = '';
        this.IsActive = false;
        this.UserId = 0;
        this.UserType = 3
    }
}
export class RoleModel {
    DepartmentId: number;
    RoleId: number;
    RoleName: string;
    TurnaroundTime: null
    IsActive: boolean;
    UserId: number;
    UserType: number

    constructor() {
        this.DepartmentId = 0
        this.RoleId = 0;
        this.RoleName = '';
        this.TurnaroundTime = null
        this.IsActive = false;
        this.UserId = 0;
        this.UserType = 3
    }
}
export class ProductModel {
    TravelCategoryId: number;
    TravelCategoryName: string;
    IsActive: boolean;
    UserId: number;

    constructor() {
        this.TravelCategoryId = 0;
        this.TravelCategoryName = '';
        this.IsActive = false;
        this.UserId = 0;
    }
}